var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13333_51384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41642 1.33203C4.73642 1.33203 1.74976 4.3187 1.74976 7.9987C1.74976 11.6787 4.73642 14.6654 8.41642 14.6654C12.0964 14.6654 15.0831 11.6787 15.0831 7.9987C15.0831 4.3187 12.0964 1.33203 8.41642 1.33203ZM7.08309 11.332L3.74976 7.9987L4.68976 7.0587L7.08309 9.44537L12.1431 4.38537L13.0831 5.33203L7.08309 11.332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13333_51384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.41626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCheckCircle);
export default __webpack_public_path__ + "static/media/icons-check-circle.2de7b4ba83f268846e80d24f179ec503.svg";
export { ForwardRef as ReactComponent };